import {AcapulcoCondoDoc, CondoDoc} from "@casas-diamante/types"
import {useMemo} from "react"

const CONDO_SEARCH_STATE_KEY = "condo-search-state"

export type CondoSearchState = {
   source: "condos"
   returnTo: string
   condos: Array<CondoDoc | AcapulcoCondoDoc>
   selectedCondoId?: string
   searchString?: string
   searchPage?: number
   lastCond?: string | null
   noMoreCond?: boolean
   scrollY: number
   classification?: string | null
}

type BuildCondoStateParams = {
   source: "condos"
   returnTo: string
   condos: Array<CondoDoc | AcapulcoCondoDoc>
   selectedCondoId?: string
   searchString?: string
   searchPage?: number
   lastCond?: string | null
   noMoreCond?: boolean
   scrollY?: number
   classification?: string | null
}

export function buildCondoSearchState(params: BuildCondoStateParams): CondoSearchState {
   return {
      source: params.source,
      returnTo: params.returnTo,
      condos: params.condos,
      selectedCondoId: params.selectedCondoId,
      searchString: params.searchString,
      searchPage: params.searchPage ?? 0,
      lastCond: params.lastCond ?? null,
      noMoreCond: params.noMoreCond ?? false,
      scrollY: params.scrollY ?? window.scrollY,
      classification: params.classification ?? null,
   }
}

export function useCondoSearchState(params: BuildCondoStateParams) {
   return useMemo(() => buildCondoSearchState(params), [params])
}

export function persistCondoSearchState(state: CondoSearchState) {
   sessionStorage.setItem(CONDO_SEARCH_STATE_KEY, JSON.stringify(state))
}

export function readPersistedCondoSearchState(): CondoSearchState | null {
   const value = sessionStorage.getItem(CONDO_SEARCH_STATE_KEY)

   if (!value) return null

   try {
      return JSON.parse(value) as CondoSearchState
   } catch {
      sessionStorage.removeItem(CONDO_SEARCH_STATE_KEY)
      return null
   }
}
